// Klaviyo sign-ups through the public Client API (Theme settings › Klaviyo).
// MP.klaviyoSubscribe({ list, email, firstName, properties, source }) subscribes a profile to a list with email
// consent; Klaviyo applies the list's own opt-in process (double or single). It resolves on success and
// rejects otherwise, so callers can fall back to the Shopify customer form.
// Newsletter forms (form.newsletter-form) are handled here as well.
(() => {
  const MP = window.MP || (window.MP = {});
  const config = MP.klaviyo || {};
  const REVISION = '2024-10-15';

  MP.klaviyoSubscribe = ({ list, email, firstName, properties, source }) => {
    if (!config.key || !list || !email) return Promise.reject(new Error('Klaviyo not configured'));
    const attributes = { email };
    if (firstName) attributes.first_name = firstName;
    if (properties && Object.keys(properties).length) attributes.properties = properties;
    return fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(config.key)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'Website',
            profile: { data: { type: 'profile', attributes } }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      })
    }).then(response => {
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
    });
  };

  // Pack names as the restock form shows them -> the values Klaviyo already uses in desired_packs.
  const packValues = new Map(String(config.packValues || '').split('\n').map(line => line.split('=').map(part => part.trim())).filter(([name, value]) => name && value).map(([name, value]) => [name.toUpperCase(), value]));
  MP.klaviyoPackValue = name => packValues.get(String(name).trim().toUpperCase()) || `${String(name).trim()} PACK`;
  // Sizes as stored by the existing Klaviyo forms (XXL is saved as 2XL there).
  MP.klaviyoSize = size => (String(size).toUpperCase() === 'XXL' ? '2XL' : String(size));

  // Newsletter: same form, same look; on success the form is replaced by its thank-you line.
  document.addEventListener('submit', event => {
    const form = event.target.closest?.('form.newsletter-form');
    if (!form || !config.key || !config.newsletter || form.dataset.klaviyoFallback) return;
    const email = form.querySelector('input[type="email"]');
    if (!email || !email.value.trim()) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    MP.klaviyoSubscribe({ list: config.newsletter, email: email.value.trim(), source: 'Website Newsletter' })
      .then(() => {
        const done = document.createElement('p');
        done.className = 'newsletter-done';
        done.setAttribute('role', 'status');
        done.textContent = form.dataset.success || 'Danke! Bitte bestätige deine Anmeldung in der E-Mail, die wir dir gerade geschickt haben.';
        form.replaceChildren(done);
      })
      .catch(() => {
        // Klaviyo unreachable: send the Shopify customer form instead, so no sign-up is lost.
        form.dataset.klaviyoFallback = '1';
        if (button) button.disabled = false;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
  });
})();
